import { render } from "./UserIcon.vue?vue&type=template&id=58eea38a&scoped=true"
const script = {}

import "./UserIcon.vue?vue&type=style&index=0&id=58eea38a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58eea38a"]])

export default __exports__